module.exports = __webpack_public_path__ + "static/media/raihpoin.6c14dac9.svg";